module.exports = __webpack_public_path__ + "img/User Management.7b509154.svg";